import { useTopJackpotContributions } from '@hooks/queries/useJackpot'
import { combineContributions, formatPercentage } from '@core/jackpot/jackpotView'
import { JACKPOT_TABLE_HEADERS, JACKPOT_MESSAGES } from '@constants/jackpotConstants'
import JackpotTable from './JackpotTable'

// The active jackpot's leaderboard + my own entry (combineContributions
// merges them — the BE already keeps "me" separate from the top list).
const JackpotTopContributionsTable = () => {
  const { data, isPending, isError } = useTopJackpotContributions()
  const rows = combineContributions(data?.top, data?.currentUser)

  return (
    <JackpotTable
      headers={JACKPOT_TABLE_HEADERS.TOP_CONTRIBUTIONS}
      rows={rows}
      isPending={isPending}
      isError={isError}
      emptyMessage={JACKPOT_MESSAGES.NO_TOP_CONTRIBUTIONS}
      renderRow={(row, index) => (
        <div
          key={row.userId ?? index}
          className={`standard-normal-jackpot-table-row ${row.isMe ? 'standard-normal-jackpot-table-row-me' : ''}`}
        >
          <div className="standard-normal-jackpot-table-cell">{row.userId}</div>
          <div className="standard-normal-jackpot-table-cell">{formatPercentage(row.winChance)}</div>
          <div className="standard-normal-jackpot-table-cell">{row.tickets}</div>
        </div>
      )}
    />
  )
}

export default JackpotTopContributionsTable
